import { useEffect, useState } from 'react';

/**
 * This uses user agent instead of breakpoints for mobile browser detection.
 * For cases such as having a user download the app or texting them the link (desktop),
 * we want to make sure we can more accurately detect their device.
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
 *
 * @returns {boolean} isMobile - Whether the user is on a mobile device or not
 */
export const useMobileDevice = (): { isMobile: boolean } => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    if (navigator && /Mobi|Android/i.test(navigator.userAgent)) {
      setIsMobile(true);
    }
  }, []);

  return { isMobile };
};
